import * as T_T from 'cryface';

export namespace RifoExlusiveValidator {
    export function titleValidator(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('楼盘名称不能为空'));
        }
        return callback();
    }
    export function priceValidator(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('转让价格不能为空'));
        }
        return callback();
    }
    export function streetNumberValidator(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('街道号不能为空'));
        }
        return callback();
    }
    export function streetNameValidator(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('街道名不能为空'));
        }
        return callback();
    }
    export function postalCodeValidator(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('邮编不能为空'));
        }
        return callback();
    }
    export function storeyValidator(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('楼层不能为空'));
        }
        return callback();
    }
    export function bedroomsValidator(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('卧室不能为空'));
        }
        return callback();
    }
    export function washroomsValidator(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('浴室卫生间不能为空'));
        }
        return callback();
    }
    export function garagesValidator(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('车库不能为空'));
        }
        return callback();
    }
    export function lotAreaValidator(rule: any, value: string, callback: any) {
        if (!T_T.simpleDetect(value)) {
            return callback(new Error('占地面积不能为空'));
        }
        return callback();
    }
    // export function taxValueValidator(rule: any, value: string, callback: any) {
    //     if (!T_T.simpleDetect(value)) {
    //         return callback(new Error('地税不能为空'));
    //     }
    //     return callback();
    // }
    // export function lotXValidator(rule: any, value: string, callback: any) {
    //     if (!T_T.simpleDetect(value)) {
    //         return callback(new Error('长度不能为空，单位为feet'));
    //     }
    //     return callback();
    // }
    // export function lotYValidator(rule: any, value: string, callback: any) {
    //     if (!T_T.simpleDetect(value)) {
    //         return callback(new Error('宽度不能为空，单位为feet'));
    //     }
    //     return callback();
    // }
}
